(() => {
  'use strict';
  const mobile = matchMedia('(max-width: 899px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const header = document.querySelector('.dama-header');
  header?.addEventListener('keydown', event => {
    if (!mobile.matches || !header.classList.contains('header--expanded')) return;
    const burger = header.querySelector('.header__burger');
    if (event.key === 'Escape') {
      event.preventDefault();
      burger?.click();
      burger?.focus();
      return;
    }
    if (event.key !== 'Tab') return;
    const controls = [...header.querySelectorAll('button:not([disabled]),a[href],summary')].filter(node => node.getClientRects().length);
    const first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });

  // Every gallery item remains available in the vertical mobile media stack.
  document.querySelectorAll('[data-dama-product-description]').forEach(content => {
    const button = content.nextElementSibling;
    if (!button?.matches('[data-dama-description-toggle]')) return;
    const paragraphs = [...content.querySelectorAll('p')].filter(p => p.textContent.trim());
    // Product copy uses a short opening phrase before the full description.
    // Emphasise that phrase only, never the entire first descriptive paragraph.
    const hasOpeningPhrase = paragraphs.length > 1 && paragraphs[0].textContent.trim().length < 80;
    if (hasOpeningPhrase) {
      paragraphs[0].classList.add('dama-product-description-lead');
    }
    // The mobile design shows the opening phrase and one complete introductory
    // sentence. Product imports sometimes put every sentence in the same <p>.
    const lead = paragraphs[hasOpeningPhrase ? 1 : 0] || content;
    const tails = [];
    const opening = lead.textContent;
    let sentenceEnd = opening.length;
    if (typeof Intl.Segmenter === 'function') {
      const sentences = new Intl.Segmenter(document.documentElement.lang || 'en', { granularity: 'sentence' });
      for (const sentence of sentences.segment(opening)) {
        sentenceEnd = sentence.index + sentence.segment.length;
        // Keep a short tagline with the next sentence in unstructured imports.
        if (opening.slice(0, sentenceEnd).trim().length >= 80) break;
      }
    }
    if (opening.slice(sentenceEnd).trim()) {
      const walker = document.createTreeWalker(lead, NodeFilter.SHOW_TEXT);
      let remaining = sentenceEnd;
      let node;
      while ((node = walker.nextNode())) {
        if (remaining > node.length) { remaining -= node.length; continue; }
        const range = document.createRange();
        range.setStart(node, remaining);
        range.setEnd(lead, lead.childNodes.length);
        const tail = document.createElement('span');
        tail.id = `${content.id}-more-${tails.length + 1}`;
        tail.className = 'dama-product-description-rest';
        // DOM extraction preserves links, emphasis and every original character.
        tail.append(range.extractContents());
        lead.append(tail);
        tails.push(tail);
        break;
      }
    }
    let boundary = lead;
    while (boundary !== content) {
      const parent = boundary.parentElement;
      const following = [];
      for (let node = boundary.nextSibling; node; node = node.nextSibling) following.push(node);
      if (following.some(node => node.textContent.trim() || node.nodeType === 1 && node.matches('img,video,iframe,table,ul,ol,hr'))) {
        const tail = document.createElement('div');
        tail.id = `${content.id}-more-${tails.length + 1}`;
        tail.className = 'dama-product-description-rest';
        parent.insertBefore(tail, following[0]);
        following.forEach(node => tail.append(node));
        tails.push(tail);
      }
      boundary = parent;
    }
    if (!tails.length) return;
    button.setAttribute('aria-controls', tails.map(tail => tail.id).join(' '));
    let expanded = false;
    function update() {
      const shown = !mobile.matches || expanded;
      tails.forEach(tail => { tail.hidden = !shown; });
      button.hidden = !mobile.matches;
      button.setAttribute('aria-expanded', String(shown));
      button.textContent = shown ? button.dataset.less : button.dataset.more;
    }
    button.addEventListener('click', () => { expanded = !expanded; update(); });
    mobile.addEventListener('change', update);
    update();
  });
})();
